import { css } from 'styled-system/css';

export const userInfoStyle = {
	meAvatarWrap: css({
		base: {
			position: 'relative',
			'& .festival-avatar-frame': {
				top: '-5px',
				right: '-5px',
				bottom: '-5px',
				left: '-5px',
			},
		},
		_mars: {
			display: 'flex',
			rounded: '50px',
			border: '2px solid {colors.brand.500}',
			bgColor: 'var(--s600)',
			'& .my-account__avatar': {
				display: 'none',
			},
		},
	}),
	meAvatar: css({
		base: {
			display: 'flex',
			alignItems: 'center',
			justifyContent: 'center',
			width: '38px',
			height: '38px',
			border: '2px solid {colors.white.0}',
			bgGradient: 'to-br',
			rounded: '20px',
			gradientFrom: { base: 'primary.50_50', _dark: 'primary.900' },
			gradientTo: { base: 'primary.50_0', _dark: 'var(--s600)' },
			'& .icon': {
				color: 'brand.500',
				width: '28px',
				height: '28px',
			},
			'& .vip-badge': {
				width: '36px',
				height: '36px',
			}
		},
		_galaxy: {
			display: 'none',
		},
	}),
	userInfo: css({
		_mars: {
			ml: '9px',
			fontWeight: '500',
		}
	}),
	setting: css({
		color: 'whiteOpacity.100',
		_mars: {
			'& .btn--switch-theme': {
				bgColor: 'brand.500',
				color: 'whiteOpacity.100',
			},
		},
	}),
	messageButton: css({
		base: {
			display: 'none',
		},
		_mars: {
			display: 'block',
			position: 'relative',
			color: 'brand.500_light',
			bgColor: 'primary.300_12',
			ml: '9px',
		}
	}),
	myVoucherButton: css({
		base: {
			position: 'relative',
			bgColor: 'var(--background-primary-500-neutral-500, var(--p500))',
			color: 'var(--background-utility-constant-white, var(--white))',
			_dark: {
				bgColor: 'var(--background-primary-500-neutral-500, var(--s400))',				
			}
		},
	}),
	badge: css({
		base: {
			_ltr: {
				right: '0px',
				left: 'auto',
			},
			_rtl: {
				left: '0px',
				right: 'auto',
			},
		},
		_galaxy: {
			top: 0,
			bgColor: 'var(--special-02)',
		},
		_mars: {
			width: '6px',
			height: '6px',
			top: '3px',
			bgColor: 'status.negative',
		},
	}),
	messageModal: css({
		_mars: {
			'& .page-header': {
				display: 'none',
			},
			'& .page-filter': {
				top: 0,
			},
			'& .message': {
				maxH: 'calc(100% - 42px)',
				overflow: 'auto',
			}
		},
	}),
}